<template>
  <div id="app">
    <div v-wechat-title='$route.meta.title'></div>
    <!--<transition >-->
      <!--<keep-alive :include="['head']">-->
    <Home-head>
    </Home-head>
        <router-view></router-view>
      <!--</keep-alive>-->
    <!--</transition>-->


  </div>
</template>

<script>
  import Homehead from './components/brand-products/head'
export default {
  name: 'App',

  components: {
    Homehead
  },

  created() {
    window.onload = function () {
      document.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      })
      document.addEventListener('gesturestart', function (event) {
        event.preventDefault()
      })
    }
  }
    }

</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
/*.el-footer {*/
  /*height: auto !important;*/
  /*line-height: inherit;*/
  /*!*background-color: #d3d5d8;*!*/
  /*background: url('./assets/img/HomePage/head/bottomimg.png') no-repeat;*/
  /*background-size: 100% 100%;*/
/*}*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue